import * as mqtt from "mqtt/dist/mqtt.min";
const Mqtt = {
    client:null,
    connect(){
        const options = {
            clientId: this.clientId,
            username: process.env.VUE_APP_MQTT_USER,
            password: process.env.VUE_APP_MQTT_PASSWORD,
            clean: true, // 保留会话
            connectTimeout: 1000, // 超时时间
            reconnectPeriod: 1000, // 重连时间间隔
        }
        this.client = mqtt.connect(process.env.VUE_APP_MQTT_HOST, options)
    },
    clientId(){
        var uid = [];
        var hexDigits = "0123456789abcdefghijklmnopqrst";
        for (var i = 0; i < 32; i++) {
            uid[i] = hexDigits.substr(Math.floor(Math.random() * 0x10), 1);
        }
        uid[6] = "4";
        uid[15] = hexDigits.substr((uid[15] & 0x3) | 0x8, 1);
        var uuid = uid.join("");
        return "client_" + uuid;
    },
    subscribe(topic,callback){
        this.client.subscribe(topic,(error)=>{
            if(!error){
                this.client.on('message', (topic, message) => {
                    var hexString = String.fromCharCode.apply(null, message);
                    var json = JSON.parse(hexString);
                    callback(json);
                })
            }else{
                console.log("订阅失败");
            }
        })
    }
};
export default Mqtt;